import { Component, TemplateRef, ViewChild } from "@angular/core";
import { UiNotificationService } from "@webapp/ui/notification/services/notification.service";

@Component({
  selector: "gh-example-notifications-component",
  templateUrl: "./example-notifications.component.html",
  styleUrls: [],
})
export class ExampleNotificationsComponent {
  public constructor(private notificationService: UiNotificationService) {}

  @ViewChild(TemplateRef, { static: false }) public template?: TemplateRef<object>;

  public ninja(): void {
    const fruits = [
      { name: "Apple", color: "red" },
      { name: "Orange", color: "orange" },
      { name: "Watermelon", color: "green" },
    ];

    fruits.forEach((fruit) => {
      this.notificationService.template(this.template, { nzData: fruit });
    });
  }

  public createBasicNotification(position = "topRight"): void {
    this.notificationService
      .blank("Notification Title", "This is the content of the notification. This is the content of the notification. This is the content of the notification.", {
        notificationPlacement: position,
      })
      .onClick.subscribe(() => {
        // eslint-disable-next-line no-console
        console.log("notification clicked!");
      });
  }

  public createNotification(type: string): void {
    this.notificationService.create(
      type,
      "Notification Title",
      "This is the content of the notification. This is the content of the notification. This is the content of the notification."
    );
  }
}
